import './styles/TestDetails.scss';

import { useClassHelper } from '@whistler-ui/k2/hooks';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TEST_STATUSES, USE_CASE } from '../../constants';
import { useTestExecutionsStore } from '../../store/testExecutions';
import {
  ExecutionTest,
  TTestTabs,
  TUseCasesApiTags,
  TUseCaseTags,
  TUseCaseType,
} from '../../types';
// Scoped Components
import { TestDetailsRenderer } from './components/TestDetailRenderer';
import { componentName } from './constants';
import { isLoadingFunc, statusFunc } from './helpers';
interface Props {
  [key: string]: any;
  activeContent: TTestTabs;
  setActiveContent: (label: TTestTabs) => void;
  testCase: any;
  type: TUseCaseType;
  tabs: TTestTabs[];
  execution?: ExecutionTest;
  tag: TUseCaseTags | TUseCasesApiTags;
}

export const TestDetails = ({
  activeContent,
  setActiveContent,
  testCase,
  type,
  tabs = [],
  tag,
}: Props) => {
  const c = useClassHelper(componentName);
  const { t } = useTranslation();
  const testExecutionKey =
    type === USE_CASE ? 'useCaseTestExecutions' : 'apiTestExecutions';
  const { [testExecutionKey]: executions } = useTestExecutionsStore();
  const execution = executions?.[tag]?.[testCase.tag];

  const status = useMemo(() => {
    return statusFunc(execution);
  }, [execution]);

  const isLoading = useMemo(() => {
    const status = statusFunc(execution);

    if ((!testCase || !execution) && status !== TEST_STATUSES.EMPTY) {
      return true;
    }

    return isLoadingFunc(status);
  }, [testCase, execution]);

  return (
    <div className={componentName}>
      <div className={c('__content-pane')}>
        <div className={c('__row')}>
          {tabs.map((section, index) => {
            const id = `section-${section}`;

            return (
              <button
                aria-controls={id}
                id={id}
                type="button"
                role="tab"
                aria-selected={activeContent === section ? 'true' : 'false'}
                key={c(`-title-${index}`)}
                className={c('__title-item', '__title-item-all', {
                  '__active-label': activeContent === section,
                })}
                onClick={() => setActiveContent(section)}
                tabIndex={0}
                data-cy={section.toLowerCase()}
              >
                {t(section)}
              </button>
            );
          })}
        </div>
        <div className={c('__information')}>
          <TestDetailsRenderer
            activeContent={activeContent}
            execution={execution as unknown as ExecutionTest}
            isLoading={isLoading}
            status={status}
            test={testCase}
            type={type}
            tag={tag}
          />
        </div>
      </div>
    </div>
  );
};
